import { useEffect } from "react";

// Injects a single <script type="application/ld+json"> tag into <head>,
// keyed by id, and removes it on unmount. No head-management library is
// used since this app has none and JSON-LD is all that's needed here.
const useJsonLd = (id, schema) => {
  useEffect(() => {
    if (!schema) return undefined;

    const scriptId = `jsonld-${id}`;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = scriptId;
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [id, schema]);
};

export default useJsonLd;
